<template>
  <!-- <div v-if="!has_perm('view_service_package')">
    <div class="col-md-12">
      <h1 style="text-align: center; color: red;">
        {{ $t("common.not_permission") }} !
      </h1>
    </div>
  </div> -->
  <div v-if="has_perm('view_service_order') || GET_ACCOUNT_DATA.group_id == 1">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t("search.title") }}</h3>
      </div>
      <div class="box-body">
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-sm-4 col-md-4 col-lg-4">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('search.title')"
              v-model="search.searchText"
              v-on:keyup.enter="onSearchServiceOrder()"
            />
          </div>
          <div
            v-if="serviceOrderStatusSelect === null"
            class="col-sm-4 col-md-4 col-lg-4"
          >
            <select
              class="form-control"
              :placeholder="$t('property.asset.status')"
              v-model="search.statusValue"
            >
              <option :value="null">---</option>
              <option
                v-for="(item, index) in serviceOrderStatusOption"
                :key="item + index"
                :value="item.value"
              >
                {{ $t(item.text) }}</option
              >
            </select>
          </div>
          <div class="col-sm-4 col-md-4 col-lg-4">
            <button
              type="button"
              class="btn btn-labeled btn-success"
              @click="onSearchServiceOrder()"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-search"></i>
              </span>
              {{ $t("search.search_button") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="box box-primary">
        <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">
            {{ $t("managementServiceOrder.title") }}
          </h3>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-12" style="text-align: right;">
              <button
                v-if="
                  has_perm('create_service_order') && serviceOrderStatusSelect
                "
                class="btn btn-primary btn-sm extra-tools"
                @click="
                  onShowChangeChangeStatusList(ServiceOrderStatusEnum.COMPLETED)
                "
              >
                <i class="glyphicon glyphicon-ok"></i>
                {{ $t("managementServiceOrder.statusList.completed") }}
              </button>
              <button
                v-if="
                  has_perm('create_service_order') && serviceOrderStatusSelect
                "
                class="btn btn-danger btn-sm extra-tools"
                @click="
                  onShowChangeChangeStatusList(ServiceOrderStatusEnum.CANCELED)
                "
              >
                <i class="glyphicon glyphicon-remove"></i>
                {{ $t("managementServiceOrder.statusList.cancel") }}
              </button>
              <button
                v-if="has_perm('create_service_order') && serviceOrderStatusSelect"
                class="btn btn-info btn-sm extra-tools"
                @click="onOpenAddInput"
              >
                <i class="glyphicon glyphicon-plus"></i>
                {{ $t("common.addnew") }}
              </button>
            </div>
            <div class="" style="display: flex; padding: 0 15px">
              <span
                v-for="(item, index) in serviceOrderStatusList"
                :key="item + index"
                :class="
                  `${
                    index !== serviceOrderStatusList.length - 1
                      ? 'customer-type-class border-right'
                      : 'customer-type-class'
                  }`
                "
                @click="onChangeTab(item.value)"
              >
                <span
                  :class="
                    item.value === serviceOrderStatusSelect
                      ? 'customer-type-select'
                      : ''
                  "
                  style="white-space: nowrap;"
                >
                  {{ $t(item.text) }}
                  {{ item.value !== null ? `(${item.total})` : null }}
                </span>
              </span>
            </div>
            <div class="col-md-12">
              <b-table
                :items="serviceOrderItems"
                :fields="serviceOrderFields"
                :tbody-tr-class="rowClass"
                class="mt-3 package-table"
                responsive
                outlined
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #head(selected)>
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="selectAllCheckBox"
                    @change="onChangeSelectAllCheckBox(selectAllCheckBox)"
                    :disabled="serviceOrderStatusSelect === null"
                  />
                </template>
                <template #cell(selected)="row">
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="row.item.rowSelected"
                    @change="onRowSelected(row.item, row.item.rowSelected)"
                    :disabled="serviceOrderStatusSelect === null"
                  />
                </template>
                <template #cell(totalFee)="row">
                  {{ currencyFormat(row.item.totalFee) }}
                </template>
                <template #cell(customerName)="row">
                  <div class="parent">
                    {{ row.item.customerName }}
                    <div
                      v-if="has_perm('update_service_order')"
                      class="show-when-hovered"
                      style="display: flex; white-space: nowrap;"
                    >
                      <span
                        class="detail-service hover-action"
                        @click="onShowDetail(row)"
                        ><small>{{ $t("common.detail") }}</small></span
                      >
                      <span
                        v-if="serviceOrderStatusSelect"
                        class="action-space-border"
                        >|</span
                      >
                      <span
                        v-if="serviceOrderStatusSelect"
                        :class="
                          `${
                            row.item.status !== ServiceOrderStatusEnum.CANCELED
                              ? 'completed-status hover-action'
                              : 'disable-btn'
                          }`
                        "
                        @click="
                          row.item.status !== ServiceOrderStatusEnum.CANCELED
                            ? onShowUpdateStatus(
                                ServiceOrderStatusEnum.COMPLETED,
                                row.item
                              )
                            : ''
                        "
                        ><small>{{
                          $t("managementServiceOrder.statusList.completed")
                        }}</small></span
                      >
                      <span
                        v-if="serviceOrderStatusSelect"
                        class="action-space-border"
                        >|</span
                      >
                      <span
                        v-if="serviceOrderStatusSelect"
                        :class="
                          row.item.status !==
                            ServiceOrderStatusEnum.COMPLETED &&
                          row.item.status !== ServiceOrderStatusEnum.CANCELED
                            ? 'cancel-status hover-action'
                            : 'disable-btn'
                        "
                        @click="
                          row.item.status !==
                            ServiceOrderStatusEnum.COMPLETED &&
                          row.item.status !== ServiceOrderStatusEnum.CANCELED
                            ? onShowUpdateStatus(
                                ServiceOrderStatusEnum.CANCELED,
                                row.item
                              )
                            : ''
                        "
                        ><small>{{
                          $t("managementServiceOrder.statusList.cancel")
                        }}</small></span
                      >
                    </div>
                  </div>
                </template>
                <template #cell(notes)="row" style="width: 40%">
                  <div
                    style="white-space: -moz-pre-wrap; 
                      white-space: pre-wrap; 
                      word-wrap: break-word;
                    "
                  >
                    <span>{{ spliceString(row.item.notes, 50) }}</span>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <div class="row">
            <div class="col-md-12">
              <paginator
                :totalItem="paginateData.totalItem"
                :currentPage="paginateData.currentPage"
                :pageSize="paginateData.pageSize"
                :totalPage="paginateData.totalPage"
                @onpaginate="onPagination"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Confirm Delete -->
      <div class="modal fade" :ref="`modal-pkg-tmpl`">
        <div class="modal-dialog">
          <confirm :id="pkg_tmpl_data.id" @confirm="onDeleteConfirm" />
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    </div>
    <div
      class="modal fade"
      :ref="`modal-update-service-status`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseServiceOrderModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(modalConfirmTitle) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  {{ $t(modalConfirmContent) }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-6 col-md-6">
                    <div class="row">
                      <div class="col-md-12">
                        <label for=""
                          >{{ $t("customer.apartment_code") }}:
                        </label>
                        {{
                          serviceOrderSelect &&
                            serviceOrderSelect.apartment_code
                        }}
                      </div>
                      <div class="col-md-12">
                        <label for=""
                          >{{ $t("apartmentBooking.customerName") }}:
                        </label>
                        {{
                          serviceOrderSelect && serviceOrderSelect.customerName
                        }}
                      </div>
                      <div class="col-md-12">
                        <label for=""
                          >{{ $t("apartmentBooking.phone") }}:
                        </label>
                        {{ serviceOrderSelect && serviceOrderSelect.phone }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <div class="row">
                      <div class="col-md-12">
                        <label for=""
                          >{{ $t("managementServiceOrder.servicePackage") }}:
                        </label>
                        {{
                          serviceOrderSelect &&
                            serviceOrderSelect.servicePackage
                        }}
                      </div>
                      <div class="col-md-12">
                        <label for=""
                          >{{ $t("managementServiceOrder.service") }}:
                        </label>
                        {{ serviceOrderSelect && serviceOrderSelect.service }}
                      </div>
                      <div class="col-md-12">
                        <label for=""
                          >{{ $t("service.servicePackage.totalFee") }}:
                        </label>
                        {{
                          currencyFormat(
                            serviceOrderSelect && serviceOrderSelect.totalFee
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseServiceOrderModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdateStatusServiceOrder"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-update-status-service-order-select-list`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseServiceOrderSelectListModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(modalConfirmTitle) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                {{ $t(modalConfirmContent) }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseServiceOrderSelectListModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdateServiceOrderSelectList"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
// import RegisterVehicleInputView from './RegisterVehicleInputView'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Confirm from "@/components/Confirm.vue";
import Paginator from "@/components/CustomPaginator.vue";
// import Loading from "vue-loading-overlay"
import utils from "@/lib/utils";
import ServiceOrderStatusEnum from "@/enum/serviceOrderStatusEnum";

export default {
  name: "PackageTemplateView",
  data() {
    return {
      isLoading: false,
      ServiceOrderStatusEnum: ServiceOrderStatusEnum,
      search: {
        searchText: null,
        statusValue: null
      },
      serviceOrderStatusSelect: ServiceOrderStatusEnum.UNFINISHED,
      serviceOrderStatusList: [
        // { value: null, text: "project.all", total: 0 },
        {
          value: ServiceOrderStatusEnum.UNFINISHED,
          text: "managementServiceOrder.statusList.unfinished",
          total: 0
        },
        {
          value: null,
          text: "common.history",
          total: 0
        }
      ],
      serviceOrderStatusParams: [ServiceOrderStatusEnum.UNFINISHED],
      //
      pkg_tmpl_data: {
        id: 0
      },
      serviceOrderItems: [],
      serviceOrderFields: [
        { key: "selected" },
        {
          key: "nonumber",
          label: "common.nonumber",
          sortable: false,
          class: "text-center"
        },
        // {
        //   key: "bookingCode",
        //   label: "apartmentBooking.bookingCode",
        //   sortable: false
        // },
        {
          key: "customerName",
          label: "apartmentBooking.customerName",
          sortable: false
        },
        {
          key: "phone",
          label: "apartmentBooking.phone",
          sortable: false
        },
        {
          key: "apartment_code",
          label: "customer.apartment_code",
          sortable: false
        },
        {
          key: "service",
          label: "managementServiceOrder.service",
          sortable: false
        },
        {
          key: "servicePackage",
          label: "managementServiceOrder.servicePackage",
          sortable: false
        },
        {
          key: "totalFee",
          label: "service.servicePackage.totalFee",
          sortable: false
        },
        {
          key: "dateOfUse",
          label: "managementServiceOrder.dateOfUse",
          sortable: false
        },
        {
          key: "notes",
          label: "managementServiceOrder.notes",
          class: "text-left description-content-width",
          sortable: false
        },
        {
          key: "dateCreate",
          label: "managementServiceOrder.dateCreate",
          sortable: false
        }
      ],
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      //
      modalConfirmTitle: "",
      modalConfirmContent: "",
      serviceOrderSelect: null,
      serviceUpdateStatus: null,
      selected: [],
      selectAllCheckBox: false,
      serviceOrderStatusOption: [
        {
          value: ServiceOrderStatusEnum.COMPLETED,
          text: "managementServiceOrder.statusList.completed"
        },
        {
          value: ServiceOrderStatusEnum.CANCELED,
          text: "managementServiceOrder.statusList.canceled"
        }
      ]
    };
  },
  watch: {
    GET_NUMBER_SERVICE_ORDER_LIST_DATA: function() {
      let data = this.GET_NUMBER_SERVICE_ORDER_LIST_DATA;
      data.forEach(v => {
        let index = this.serviceOrderStatusList.findIndex(
          x => x.value === v.value
        );
        if (index !== -1) {
          this.serviceOrderStatusList[index].total = v.total;
        }
      });
    },
    GET_SERVICE_ORDER_LIST_DATA: function() {
      let paginate = this.GET_SERVICE_ORDER_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_SERVICE_ORDER_LIST_DATA.results;
      this.serviceOrderItems = [];
      this.selected = [];
      data.forEach((v, i) => {
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          id: v.id,
          nonumber: nonumber,
          status: v.status,
          apartment_code: utils.getCleanStringValue(v.apartment_data.apartment_name, v.apartment_data.apartment_code),
          customerName: v.customer_name,
          phone: v.customer_phone,
          service: v.service_data.name,
          servicePackage: v.service_package_data.package_name,
          totalFee: v.total_fee,
          dateOfUse: utils.formatSqlDate(v.date_of_use, null, "HH:mm DD-MM-YYYY"),
          notes: v.description,
          dateCreate: utils.formatSqlDate(v.date_created, null, "HH:mm DD-MM-YYYY"),
          rowSelected: false
        };
        this.serviceOrderItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_NUMBER_SERVICE_ORDER_LIST_DATA",
      "GET_SERVICE_ORDER_LIST_DATA",
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    rowClass: function(item, type) {
      if (!item || type !== "row") return;
      // if (item.status === ServiceOrderStatusEnum.PAYMENT) {
      //   return "description-width payment-class-bg";
      // } else 
      if (item.status === ServiceOrderStatusEnum.CANCELED) {
        return "description-width service-cancel-class-bg";
      } else return "description-width";
    },
    spliceString: function(strText, len) {
      return utils.spliceString(strText, len);
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    formatNumber: function(n) {
      return utils.formatNumber(n);
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    onOpenAddInput: function() {
      this.$router.push({
        name: "ManagementServiceOrderDetail",
        params: {
          id: 0
        },
        query: {
          serviceOrderSelectQuery: this.serviceOrderStatusSelect
        }
      });
    },
    onShowDetail: function(row) {
      let id = row.item.id;
      this.$router.push({
        name: "ManagementServiceOrderDetail",
        params: {
          id: id
        },
        query: {
          serviceOrderSelectQuery: this.serviceOrderStatusSelect
        }
      });
    },
    onOpenDeletePakageTemplateConfirm: function(row) {
      this.pkg_tmpl_data.id = row.item.id;
      this.onToggleDeleteConfirm();
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-pkg-tmpl`]).modal(action);
    },
    onDeleteConfirm: function(id) {
      const payload = {
        id: id
      };
      this.DELETE_PACKAGE_TEMPLATE(payload).then(
        function() {
          this.onToggleDeleteConfirm("hide");
          this.GET_PACKAGE_TEMPLATE_LIST();
        }.bind(this)
      );
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getServiceOrderList(data);
    },
    //
    onSearchServiceOrder: function() {
      this.getServiceOrderList(1);
      this.getNumberServiceOrder();
    },
    getServiceOrderList: function(page) {
      let filter = {
        params: {
          page: page,
          status: this.serviceOrderStatusParams,
          searchText: this.search.searchText,
          statusParams: this.search.statusValue
        }
      };
      this.isLoading = true;
      this.GET_SERVICE_ORDER_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // this.ON_SHOW_TOAST({
            //   message: error.response.data.message,
            //   styleType: "danger"
            // });
          }.bind(this)
        );
    },
    onChangeTab: function(value) {
      this.serviceOrderStatusSelect = value;
      if (value === ServiceOrderStatusEnum.UNFINISHED) {
        this.serviceOrderStatusParams = [
          ServiceOrderStatusEnum.UNFINISHED,
          ServiceOrderStatusEnum.PAYMENT
        ];
        this.search.statusValue = null;
      } else if (value !== null) {
        this.serviceOrderStatusParams = [value];
        this.search.statusValue = null;
      } else {
        this.serviceOrderStatusParams = [
          ServiceOrderStatusEnum.COMPLETED,
          ServiceOrderStatusEnum.CANCELED
        ];
      }
      this.getServiceOrderList(1);
    },
    getNumberServiceOrder: function() {
      this.GET_NUMBER_SERVICE_ORDER_LIST();
    },
    onCloseServiceOrderModal: function() {
      $(this.$refs[`modal-update-service-status`]).modal("hide");
    },
    onShowServiceOrderModal: function() {
      $(this.$refs[`modal-update-service-status`]).modal("show");
    },
    onShowUpdateStatus: function(statusValue, data) {
      if (statusValue === ServiceOrderStatusEnum.COMPLETED) {
        this.modalConfirmTitle = "managementServiceOrder.confirmCompleted";
        this.modalConfirmContent =
          "managementServiceOrder.confirmCompletedContent";
      } else if (statusValue === ServiceOrderStatusEnum.PAYMENT) {
        this.modalConfirmTitle = "managementServiceOrder.confirmPayment";
        this.modalConfirmContent =
          "managementServiceOrder.confirmPaymentContent";
      } else if (statusValue === ServiceOrderStatusEnum.CANCELED) {
        this.modalConfirmTitle = "managementServiceOrder.confirmCancel";
        this.modalConfirmContent =
          "managementServiceOrder.confirmCancelContent";
      }
      this.serviceOrderSelect = data;
      this.serviceUpdateStatus = statusValue;
      this.onShowServiceOrderModal();
    },
    onUpdateStatusServiceOrder: function() {
      let data = {
        id: this.serviceOrderSelect && this.serviceOrderSelect.id,
        status: this.serviceUpdateStatus
      };
      this.isLoading = true;
      this.UPDATE_SERVICE_ORDER_STATUS(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.getServiceOrderList(this.paginateData.currentPage);
            this.getNumberServiceOrder();
            this.onCloseServiceOrderModal();
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    onRowSelected(item, value) {
      let index = this.selected.findIndex(x => x.id === item.id);
      if (value) {
        if (index === -1) {
          this.selected.push(item);
        }
      } else {
        if (index !== -1) {
          this.selected.splice(index, 1);
        }
      }
      // this.selected = items;
      if (this.selected.length === this.serviceOrderItems.length) {
        this.selectAllCheckBox = true;
      } else {
        this.selectAllCheckBox = false;
      }
    },
    onChangeSelectAllCheckBox: function(value) {
      let serviceOrderLength = this.serviceOrderItems.length;
      let data = this.serviceOrderItems;
      this.selected = [];
      for (let i = 0; i < serviceOrderLength; i++) {
        data[i].rowSelected = value;
        if (value) {
          this.selected.push(data[i]);
        }
      }
    },
    // action change status service order select
    onShowChangeChangeStatusList: function(statusValue) {
      if (this.selected.length === 0) {
        this.showError(
          this.$t("managementServiceOrder.errorSelectServiceOrder")
        );
      } else {
        if (statusValue === ServiceOrderStatusEnum.COMPLETED) {
          this.modalConfirmTitle = "managementServiceOrder.confirmCompleted";
          this.modalConfirmContent =
            "managementServiceOrder.confirmCompletedSelectListContent";
        }
        if (statusValue === ServiceOrderStatusEnum.CANCELED) {
          this.modalConfirmTitle = "managementServiceOrder.confirmCancel";
          this.modalConfirmContent =
            "managementServiceOrder.confirmCancelSelectListContent";
        }
        this.serviceUpdateStatus = statusValue;
        this.onShowServiceOrderSelectListModal();
      }
    },
    onCloseServiceOrderSelectListModal: function() {
      $(this.$refs[`modal-update-status-service-order-select-list`]).modal("hide");
    },
    onShowServiceOrderSelectListModal: function() {
      $(this.$refs[`modal-update-status-service-order-select-list`]).modal("show");
    },
    onUpdateServiceOrderSelectList: function() {
      let data = {
        service_list: this.selected,
        status: this.serviceUpdateStatus
      };
      this.isLoading = true;
      this.UPDATE_SERVICE_ORDER_SELECT_LIST(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.getServiceOrderList(this.paginateData.currentPage);
            this.getNumberServiceOrder();
            this.onCloseServiceOrderSelectListModal();
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_SERVICE_ORDER_LIST",
      "GET_NUMBER_SERVICE_ORDER_LIST",
      "UPDATE_SERVICE_ORDER_STATUS",
      "UPDATE_SERVICE_ORDER_SELECT_LIST"
    ])
  },
  mounted() {
    //
    let serviceOrderSelectQuery = this.$route.query.serviceOrderSelectQuery
    if (serviceOrderSelectQuery !== undefined) {
      this.serviceOrderStatusSelect = serviceOrderSelectQuery
      this.onChangeTab(this.serviceOrderStatusSelect)
    }
    this.onChangeTab(this.serviceOrderStatusSelect)
    this.onSearchServiceOrder();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    confirm: Confirm,
    paginator: Paginator,
    loading: Loading
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.package-table {
  table-layout: fixed;
}

.package-table-td {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.customer-type-class {
  padding: 5px 15px;
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #000000 !important;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}
/*  */
.disable-btn {
  color: #7d7d7d;
  cursor: no-drop;
}
.detail-service {
  color: #006ad4;
}
.completed-status {
  color: green;
}
.payment-status {
  color: blue;
}
.cancel-status {
  color: red;
}
.hover-action {
  cursor: pointer;
}
.hover-action:hover {
  text-decoration: underline;
  // font-weight: bold;
}
.action-space-border {
  margin: 0 3px;
}
.table-responsive
  /deep/
  .b-table
  .description-width
  .description-content-width {
  width: 15%;
}
.table-responsive /deep/ .b-table .payment-class-bg {
  background: #00bcd473;
}

.table-responsive /deep/ .b-table .service-cancel-class-bg {
  background: #f5c6cb;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ManagementServiceOrder.vue